/*
  Project: Unit
  Author: Via Studios
 */

import initToggles from './modules/toggles';
import { initPlayOnHover } from './modules/hovers';
import initGallerySlider from './modules/gallery-slider';
import infiniteContent from './modules/infinite-content';
import './modules/menu-anchor';

document.addEventListener('DOMContentLoaded', () => {
  initToggles();
  infiniteContent();
  initPlayOnHover();
});

initGallerySlider();



// WEBPACK FOOTER //
// ./src/scripts/app.js